var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({attrs:{"tabindex":_vm.attrs.hasOwnProperty('readonly') ? -1 : 0,"id":_vm.uuid},domProps:{"value":_vm.value},on:{"input":_vm.input}},'select',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }